import script from "./ArticleList.vue?vue&type=script&setup=true&lang=js"
export * from "./ArticleList.vue?vue&type=script&setup=true&lang=js"

import "./ArticleList.vue?vue&type=style&index=0&id=0d338b82&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d338b82"]])

export default __exports__